// src/store/api/baseApi.js
// ✅ Fix sécurité tokens :
//   - sessionStorage au lieu de localStorage (effacé à la fermeture de l'onglet)
//   - Préfixe __pm__ pour éviter les collisions
//   - Pas de données sensibles dans le token lui-même côté client
//   - Pour production : utiliser des cookies httpOnly (nécessite modification backend)
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api";

// ✅ Clés préfixées — sessionStorage (pas localStorage)
const KEY_TOKEN   = "__pm__access_token";
const KEY_REFRESH = "__pm__refresh_token";

export const getAccessToken  = () => sessionStorage.getItem(KEY_TOKEN);
export const getRefreshToken = () => sessionStorage.getItem(KEY_REFRESH);

export const setTokens = (accessToken, refreshToken) => {
  if (accessToken)  sessionStorage.setItem(KEY_TOKEN,   accessToken);
  if (refreshToken) sessionStorage.setItem(KEY_REFRESH, refreshToken);
};

export const clearTokens = () => {
  sessionStorage.removeItem(KEY_TOKEN);
  sessionStorage.removeItem(KEY_REFRESH);
  // Nettoyer aussi l'ancienne clé localStorage si elle existe (migration)
  localStorage.removeItem("auth_token");
  localStorage.removeItem("auth_refresh_token");
};

// ── Base query avec Bearer token ──────────────────────────────────
const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth?.accessToken || getAccessToken();
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("Accept", "application/json");
    return headers;
  },
});

// ── Wrapper : 401 → logout propre ────────────────────────────────
const baseQueryWithReauth = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    api.dispatch({ type: "auth/logout" });
    clearTokens();
    // Effacer aussi user en sessionStorage
    sessionStorage.removeItem("__pm__user");
  }
  return result;
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "User", "Stagiaires", "Presences", "QrTokens",
    "Messages", "Sanctions", "Notifications",
    "Conversations", "Conversation", "UnreadStats",
  ],
  endpoints: () => ({}),
});